export enum Events {
	Chatbot = 'navigateToChatbot',
	ConsentConfiguration = 'navigateToConsentConfiguration',
	Shops = 'navigateToShops',
	NavigateToProducts = 'navigateToProducts',
	AddToCart = 'addToCart',
	InitNativeGooglePay = 'initNativeGooglePayPurchaseWithData',
	InitNativeApplePay = 'initNativeApplePayPurchaseWithData',
}
